import { useEffect, useRef } from "react";

type StickyScrollWrapperProps = {
  children: React.ReactNode;
  refId?: string;
  refObj?: React.Ref<HTMLElement>;
};

export default function StickyScrollWrapper({ children, refId, refObj }: StickyScrollWrapperProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const wrapper = containerRef.current;
    let footer: HTMLElement | null = null;
    if (refObj && typeof refObj !== "function" && "current" in refObj) {
      footer = refObj.current;
    } else if (typeof refId === "string") {
      footer = document.getElementById(refId);
    }

    function onScroll() {
      if (!wrapper || !footer) return;

      const wrapperRect = wrapper.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();

      // If the bottom of the wrapper would overlap the top of the footer
      if (wrapperRect.bottom > footerRect.top) {
        wrapper.style.position = "absolute";
        wrapper.style.top = `${window.scrollY + footerRect.top - wrapper.offsetHeight}px`;
      } else {
        wrapper.style.position = "sticky";
        wrapper.style.top = "20px";
      }
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [refObj, refId]);

  return <div ref={containerRef}>{children}</div>;
}
